import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import { css } from '@emotion/react';
import { cloneElement } from 'react';
import { Spinner } from '../spinner/Spinner.js';
import { visuallyHidden } from '../../foundations/accessibility/visually-hidden.js';
const buttonContents = ({ hideLabel, iconSvg, isLoading, children }) => {
    const contents = [children];
    if (isLoading) {
        if (!hideLabel) {
            contents.push(/* @__PURE__ */ jsx("div", { className: "src-button-space" }, "space"));
        }
        contents.push(cloneElement(
        /* @__PURE__ */ jsx(Spinner, {
            theme: {
                background: "transparent",
                color: "currentColor"
            }
        }), {
            key: "svg"
        }));
    }
    else if (iconSvg) {
        if (!hideLabel) {
            contents.push(/* @__PURE__ */ jsx("div", { className: "src-button-space" }, "space"));
        }
        contents.push(cloneElement(iconSvg, { key: "svg" }));
    }
    if (hideLabel) {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx("span", {
                    css: css `
						${visuallyHidden};
					`,
                    children
                }),
                contents[1]
            ] });
    }
    else {
        return contents;
    }
};
export { buttonContents };
